export default "__VITE_ASSET__CmwU$8SQ__"